export const featuredTours = [
  {
    id: "zanzibar-shores",
    title: "Zanzibar Shores",
    place: "East Coast, Zanzibar",
    days: 5,
    summary:
      "Quiet days on the east coast. Reef swimming, long lunches, and evenings with nothing on the clock.",
    image:
      "https://images.unsplash.com/photo-1506929562872-bb421503ef21?auto=format&fit=crop&w=1400&q=80",
    imageAlt: "Clear tropical shoreline and shallow turquoise water",
  },
  {
    id: "stone-town-spice",
    title: "Stone Town and Spice",
    place: "Stone Town, Zanzibar",
    days: 4,
    summary:
      "Alleys, doors, and rooftop coffee by day. A spice farm visit and a dhow sail when the wind is kind.",
    image:
      "https://images.unsplash.com/photo-1489392191049-fc10c97e64b6?auto=format&fit=crop&w=1400&q=80",
    imageAlt: "Wooden dhow on clear tropical water",
  },
  {
    id: "safari-to-zanzibar",
    title: "Plains to the Island",
    place: "Northern Circuit to Zanzibar",
    days: 8,
    summary:
      "A short safari on the mainland, then a soft landing on Zanzibar for beach days that start late.",
    image:
      "https://images.unsplash.com/photo-1516026672322-bc52d61a55d5?auto=format&fit=crop&w=1400&q=80",
    imageAlt: "Acacia tree at dusk on open plains",
  },
];

export const destinations = [
  {
    name: "Zanzibar",
    line: "East coast beaches, reef, and lodges set above the tide.",
    image:
      "https://images.unsplash.com/photo-1506929562872-bb421503ef21?auto=format&fit=crop&w=1200&q=80",
    imageAlt: "Quiet tropical shoreline and clear shallow water",
  },
  {
    name: "Stone Town",
    line: "History, markets, and the old harbor, walked at a human pace.",
    image:
      "https://images.unsplash.com/photo-1547471080-7cc2caa01a7e?auto=format&fit=crop&w=1200&q=80",
    imageAlt: "Warm coastal landscape under open sky",
  },
  {
    name: "Mainland Tanzania",
    line: "Optional safari days before you cross to the island.",
    image:
      "https://images.unsplash.com/photo-1516026672322-bc52d61a55d5?auto=format&fit=crop&w=1200&q=80",
    imageAlt: "Acacia tree on open Tanzanian plains",
  },
];

export const approach = [
  {
    title: "Zanzibar first",
    text: "Most of our trips begin or end on the island. The coast sets the tone for how we plan the rest.",
  },
  {
    title: "Groups stay small",
    text: "We keep departures intimate so your guide, boat, or vehicle belongs to your party.",
  },
  {
    title: "Stays we know",
    text: "Every lodge and town house is one our team has checked in person, not a brochure pick.",
  },
];
